import { setErrorFlag } from "../store/slices/errorConfig";
import { API_URL, API_TOKEN } from "./sys";



export const FetchRetailers = `${API_URL}/retailers`;
export const SendOTP = `${API_URL}/otp/send`;
export const VerifyOTPs = `${API_URL}/otp/verify`;

export const get = async (endpoint: string, params?: Record<string, string>): Promise<any> => {
  const storedUserData = await localStorage.getItem("userData");
  const parsedUserData = storedUserData ? JSON.parse(storedUserData) : null;
  const userId = parsedUserData?.partner_id || parsedUserData?.user_id || '';
  const loginRole = parsedUserData?.partner_type || parsedUserData?.role || '';
  const url = new URL(`${API_URL}${endpoint}`);
  if (params) {
    Object.entries(params).forEach(([key, value]) =>
      url.searchParams.append(key, value)
    );
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_TOKEN,
      "userId": userId,
      "userrole": loginRole,
    } as HeadersInit
    })

  if (response.ok) {
    if (response.status === 204) {
      console.log("No content returned from the server.");
      return null;
    } else if (response.status === 200) {
      const data = await response.json();
      return data;
    } else {
      const errorText = await response.text();
      throw new Error(`HTTP error ${response.status}: ${errorText}`);
    }
  } else {
    
    const errorText = await response.text();
    throw new Error(`HTTP error ${response.status}: ${errorText}`);
  }
};

export const post = async (endpoint: string, data: any): Promise<any> => {
  const storedUserData = await localStorage.getItem("userData");
  const parsedUserData = storedUserData ? JSON.parse(storedUserData) : null;
  console.log("Parsed User Data:", parsedUserData);
   const userId = parsedUserData?.partner_id || parsedUserData?.user_id || '';
  const loginRole = parsedUserData?.partner_type || parsedUserData?.role || '';
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_TOKEN,
      "userId": userId,
      "userrole": loginRole,
    }as HeadersInit,
    body:data,
  });

  const responseData = await response.json();

  if (response.ok) {
    // console.log("REQUEST FINE");
    return responseData;
  } else {
    if (
      responseData.message === "Failed to create retailer" &&
      response.status === 500
    ) {
      window.alert(
        "A survey is already under progress/completed for this user, please contact your Admin for more info"
      );
      return;
    } else if (response.status === 409) {
      return { ...responseData, status: response.status };
    } else {
      window.alert("Something went Wrong!");
      return;
    }
  }
};


export const put = async (endpoint: string, data: any): Promise<any> => {
  const storedUserData = await localStorage.getItem("userData");
  const parsedUserData = storedUserData ? JSON.parse(storedUserData) : null;
  
  const userId = parsedUserData?.partner_id || parsedUserData?.user_id || '';
  const loginRole = parsedUserData?.partner_type || parsedUserData?.role || '';
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_TOKEN,
      "userId": userId,
      "userrole": loginRole,
    }as HeadersInit,
    body:JSON.stringify(data),
  });

  const responseData = await response.json();

  if (response.ok) {
    // console.log("REQUEST FINE");
    return responseData;
  } else {
    if (
      responseData.message === "Failed to create retailer" &&
      response.status === 500
    ) {
      window.alert(
        "A survey is already under progress/completed for this user, please contact your Admin for more info"
      );
      return;
    } else if (response.status === 409) {
      return { ...responseData, status: response.status };
    } else {
      window.alert("Something went Wrong!");
      return;
    }
  }
};
